/* Info Dropdown Animations */
function setProperHeight(info) {
  if (info && info.style.height !== '0px') {
    info.style.height = 'auto';
    const scrollHeight = info.scrollHeight;
    info.style.height = scrollHeight + 12 + 'px';
  }
}

function toggleInfo(infoId, arrowId) {
  var info = document.getElementById(infoId);
  var arrow = document.getElementById(arrowId);

  if (arrow) {
    arrow.classList.toggle('rotate');
  }

  if (info) {
    if (info.style.height === '0px' || info.style.height === '') {
      const scrollHeight = info.scrollHeight;
      info.style.height = scrollHeight + 12 + 'px';
      info.style.opacity = 1;
    } else {
      info.style.height = '0';
      info.style.opacity = 0;
    }
  }
}

window.addEventListener('resize', function () {
  var allInfoElements = document.querySelectorAll('.deo_info');
  allInfoElements.forEach(setProperHeight);
});

document.addEventListener('DOMContentLoaded', function () {
  /* Dynamic buttons creation */
  const imageWrapper = document.querySelector('.deo_image_wrapper');
  const images = imageWrapper.querySelectorAll('.deo_product');
  const buttonWrapper = document.querySelector('.deo_dots_wrapper');

  // Clear existing buttons
  buttonWrapper.innerHTML = '';

  // Create buttons based on the number of images
  images.forEach((index) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'button deo_dots';
    button.setAttribute('aria-label', `Talgh Deodorant Product Image`);
    buttonWrapper.appendChild(button);
  });

  const buttons = buttonWrapper.querySelectorAll('.deo_dots');
  let currentIndex = 0;
  let cycleInterval;

  function updateActiveState() {
    images.forEach((img, idx) => {
      img.classList.toggle('active', idx === currentIndex);
    });
    buttons.forEach((button, idx) => {
      button.classList.toggle('active', idx === currentIndex);
    });
  }

  function cycleImages() {
    if (window.innerWidth < 1200) {
      return;
    }
    const allImagesLoaded = Array.from(images).every((image) => image.complete);
    if (!allImagesLoaded) {
      setTimeout(cycleImages, 500);
      return;
    }
    currentIndex = (currentIndex + 1) % images.length;
    updateActiveState();
  }

  function resetAndCycleImages() {
    clearInterval(cycleInterval);
    cycleInterval = setInterval(cycleImages, 3500);
  }

  function setImage(index) {
    currentIndex = index;
    updateActiveState();
    resetAndCycleImages();
  }

  function advanceImage() {
    currentIndex = (currentIndex + 1) % images.length;
    updateActiveState();
    resetAndCycleImages();
  }

  // Initial setup
  if (images.length > 0) {
    images[0].classList.add('active');
  }

  if (buttons.length > 0) {
    buttons[0].classList.add('active');
  }

  if (buttons.length) {
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => setImage(index));
    });
  }

  images.forEach((image) => {
    image.addEventListener('click', advanceImage);
  });

  resetAndCycleImages();

  /* Intersection Observer for active state */
  let observer;
  function initializeObserver() {
    if (observer) {
      observer.disconnect();
    }

    if (window.innerWidth < 930) {
      const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.6,
      };

      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            images.forEach((img, index) => {
              if (img === entry.target) {
                currentIndex = index;
                updateActiveState();
              }
            });
          }
        });
      }, observerOptions);

      images.forEach(function (image) {
        observer.observe(image);
      });
    }
  }
  initializeObserver();
  window.addEventListener('resize', function () {
    initializeObserver();
  });

  /* Scent select */
  const variantSelector = document.getElementById('variant-selector');
  const productScentInput = document.getElementById('product_scent');

  if (variantSelector.options.length > 0) {
    const defaultOption = variantSelector.options[0];
    productScentInput.value = defaultOption.getAttribute('data-scent');
    selectedVariantId = defaultOption.getAttribute('data-variant-id');
  }

  variantSelector.addEventListener('change', (event) => {
    const selectedOption = event.target.options[event.target.selectedIndex];
    productScentInput.value = selectedOption.getAttribute('data-scent');
    selectedVariantId = selectedOption.getAttribute('data-variant-id');
    updateButtonVisibility(selectedOption);
  });

  function updateScentUI(scentSelect) {
    const selectedOption = scentSelect.options[scentSelect.selectedIndex];
    const selectedVariantId = selectedOption.getAttribute('data-variant-id');

    document.querySelectorAll('.scent-notes, .ingredients-list, .scent-desc').forEach(function (element) {
      element.style.display = 'none';
    });

    const activeScentDescription = document.querySelector('.scent-desc[data-variant-id="' + selectedVariantId + '"]');
    const activeScentNotes = document.querySelector('.scent-notes[data-variant-id="' + selectedVariantId + '"]');
    const activeIngredients = document.querySelector('.ingredients-list[data-variant-id="' + selectedVariantId + '"]');
    const scents = document.getElementById('info1');
    const ingredients = document.getElementById('info2');

    if (activeScentNotes) {
      activeScentDescription.style.display = 'flex';
      activeScentNotes.style.display = 'flex';
      setProperHeight(scents);
    }

    if (activeIngredients) {
      activeIngredients.style.display = 'flex';
      setProperHeight(ingredients);
    }
  }

  function updateButtonVisibility(selectedOption) {
    const inStock = selectedOption.getAttribute('data-in-stock') > 0;
    const cartMessage = document.querySelector('.order');
    const outOfStockMessage = document.querySelector('.stock');

    if (inStock) {
      cartMessage.classList.add('active');
      cartMessage.classList.remove('hide');
      outOfStockMessage.classList.add('hide');
      outOfStockMessage.classList.remove('active');
    } else {
      cartMessage.classList.add('hide');
      cartMessage.classList.remove('active');
      outOfStockMessage.classList.add('active');
      outOfStockMessage.classList.remove('hide');
    }
  }

  const forms = document.querySelectorAll('.deo_wrapper');

  forms.forEach(function (form) {
    var scentSelect = form.querySelector('.deo_select_wrapper select');
    var cartMessage = form.querySelectorAll('.orders');
    var addedButton = form.querySelectorAll('.added');

    scentSelect.addEventListener('change', function () {
      updateScentUI(scentSelect);
      updateButtonVisibility(scentSelect.options[scentSelect.selectedIndex]);
      cartMessage.forEach((button) => button.classList.remove('hide', 'active'));
      addedButton.forEach((button) => button.classList.remove('hide', 'active'));
    });

    if (scentSelect.options.length > 0) {
      scentSelect.selectedIndex = 0;
      updateScentUI(scentSelect);
      updateButtonVisibility(scentSelect.options[0]);
    }
  });
});
